import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import { FiArrowLeft, FiPlus, FiXCircle } from "react-icons/fi";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { NumericFormat, PatternFormat } from "react-number-format";
import { useEffect, useState } from "react";

import bancos from "bancos-brasileiros";
import InputMask from "react-input-mask";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { dateForAPI } from "../../../../constants/dataFormat";
import ExtratoApi from "../../../../services/ExtratoAPI";
import TransferApi from "../../../../services/transferApi";
import SysTypesApi from "../../../../services/sysTypesApi";
import {
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  GRAY_NEUTRAL,
  REDMONEDD,
  VARIANT,
  WHITE,
} from "../../../../constants/colors";
import { goToTransferSolicitationList } from "../../../../routes/coordinator";
import BankSelector from "../../../../defaultComponents/bankSelector";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import SelectFavorite from "./Selectfavorite";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import { LoggedUser } from "../../../../atoms/userLogged";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import ModalSendACodeToLogin from "../../../login/components/modalSendACodeToLogin";

export default function AddTransfer() {
  const navigate = useNavigate();

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];

  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [favorite, setFavorite] = useState<Favorites>();

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);

  // console.log("id selecionado", id);

  interface IFormInputs {
    idCliente: number;
    idTipoConta: number;
    nomeDestinatario: string;
    cnpjDestinatario: string;
    observacao: string;
    nroBanco: string;
    nroAgencia: string;
    nroAgenciaDigito: string;
    nroConta: string;
    nroContaDigito: string;
    valor: number;
    data: string;
  }

  const initialValues = {
    idCliente: 0,
    idTipoConta: favorite ? favorite.idTipoConta : 1,
    nomeDestinatario: favorite ? favorite.nomeTitular : "",
    cnpjDestinatario: favorite ? favorite.docTitular : "",
    observacao: "",
    nroBanco: favorite ? favorite.nroBanco : "001",
    nroAgencia: favorite ? favorite.nroAgencia : "",
    nroAgenciaDigito: favorite ? favorite.nroAgenciaDigito : "",
    nroConta: favorite ? favorite.nroConta : "",
    nroContaDigito: favorite ? favorite.nroContaDigito : "",
    valor: 0,
    data: moment(new Date()).format(dateForAPI),
  };
  useEffect(() => {
    setPagamento(initialValues);
    // console.log("favorite", favorite);
  }, [favorite]);

  const [pagamento, setPagamento] = useState<IFormInputs>(initialValues);
  const [listaPagamento, setListaPagamento] = useState(Array<IFormInputs>);
  const [loading, setLoading] = useState(false);
  const [loadingCadastro, setLoadingCadastro] = useState(false);

  const schema = yup
    .object({
      vencimento: yup
        .string()
        .required("A data de vencimento deve ser preenchida!"),
      codigoBarras: yup.string().required("Digite o código de barras!"),
      // hora: yup.string().required("A hora do laançamento deve ser preenchida"),
      // valorNominal: yup.number().required("O valorNominal deve ser preenchido")
    })
    .required();
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>({ resolver: yupResolver(schema) });

  async function getSaldo() {
    try {
      setLoading(true);

      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      // setSaldoCliente(
      //   response.data[0] &&
      //     response.data[0].saldoAnterior + response.data[0].saldoPeriodo
      // );
      setSaldoCliente(
        response.data[0] &&
        parseFloat(
          (
            response.data[0].saldoAnterior + response.data[0].saldoPeriodo
          ).toFixed(2)
        )
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao carregar saldo, por favor recarregue a página.");
    }
  }
  useEffect(() => {
    if (id !== 0) {
      getSaldo();
    } else {
    }
  }, [id]);

  function onSubmit(codeRecieve: string) {
    setLoadingCadastro(true);
    const validarData = new Date();
    if (
      pagamento.cnpjDestinatario !== "" &&
      pagamento.nomeDestinatario !== "" &&
      pagamento.nroAgencia !== "" &&
      pagamento.nroConta !== "" &&
      pagamento.nroContaDigito !== "" &&
      pagamento.valor > 0 &&
      pagamento.idTipoConta > 0
    ) {
      if (saldoCliente >= pagamento.valor) {
        const objeto = {
          idCliente: id,
          idTipoConta: pagamento.idTipoConta,
          nomeDestinatario: pagamento.nomeDestinatario,
          cnpjDestinatario: unMask(pagamento.cnpjDestinatario),
          observacao: pagamento.observacao,
          nroBanco: pagamento.nroBanco,
          nroAgencia: pagamento.nroAgencia,
          nroAgenciaDigito: "D",
          nroConta: pagamento.nroConta,
          nroContaDigito: pagamento.nroContaDigito,
          valor: pagamento.valor,
          dataTransferencia: moment(new Date()).format(dateForAPI),
        };
        try {
          postTransferencias(objeto, codeRecieve);
          // console.log("objeto", objeto);
        } catch (error) {
          setLoadingCadastro(false);
          toast.error(
            "Erro ao cadastrar transferencia, por favor recarregue a página."
          );
        }
      } else {
        toast.error("O saldo não é suficiente para a solicitação!");
        setLoadingCadastro(false);
      }
    } else {
      toast.error(
        "Preencha os dados para realizar a solicitação de transferência!"
      );
      setLoadingCadastro(false);
    }
  }

  // const validarSeFinalDeSemana = () => {
  //   const validarData = new Date();
  //   const NaoFinalDeSemana =
  //     validarData.getDay() !== 5 && validarData.getDay() !== 6;
  //   const e_valido = validarMesmoDiaEAntesDasDezesseisHoras(validarData);
  //   if (e_valido) {
  //     if (NaoFinalDeSemana) {
  //       setPagamento({
  //         ...pagamento,
  //         data: moment(validarData).format("YYYY-MM-DDTHH:mm:ss.SSS"),
  //       });
  //       return true;
  //     } else {
  //       toast.error("A data não pode ser um final de semana!");
  //       return false;
  //     }
  //   } else {
  //     toast.error(
  //       "Não é possível realizar solicitações para o mesmo dia após as 16hs!"
  //     );
  //     return false;
  //   }
  // };

  function validarMesmoDiaEAntesDasDezesseisHoras(data: any) {
    const horaDaSolicitacao = moment().format("HH.mm");
    const diadaSolicitação =
      moment().format("DD-MM-YYYY") === moment(data).format("DD-MM-YYYY");
    if (diadaSolicitação) {
      if (Number(horaDaSolicitacao) < 16) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  const [code, setCode] = useState("");

  async function postTransferencias(obj: {}, codeRecieve: string) {
    setLoadingCadastro(true);
    const array = [];
    array.push(obj);
    try {
      const response = await TransferApi.postTransferSolicitation(
        array,
        codeRecieve
      );
      toast.success("Solicitações de transferências registradas com sucesso!");
      toast.success("Sua transferência será processado em breve!");
      setRefreshGlobal(refresh + 1);
      setPagamento(initialValues);
      goToTransferSolicitationList(navigate);
      setLoadingCadastro(false);
    } catch (error) {
      toast.error("Não foi possível cadastrar as solicitações");
      setLoadingCadastro(false);
      console.log("error: " + error);
    }
  }

  // function onChangeDescontoFilter(e: any) {
  //     setPagamento({ ...pagamento, descontos: Number(e.slice(3).replace(",", ".")) });
  // }
  function OnChangeValueInput(e: any) {
    setPagamento({ ...pagamento, valor: Number(e.slice(3).replace(",", ".")) });
  }
  // function OnChangeJurosInput(e: any) {
  //     setPagamento({ ...pagamento, juros: Number(e.slice(3).replace(",", ".")) });
  // }

  function sumPaymentList() {
    const valores = listaPagamento
      .map((item: any) => item.valorNominal)
      .reduce((a, b) => a + b, 0);
    return valores;
  }

  let soma = sumPaymentList().toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  const bancoOptions = bancos.map((banco: any, i: any) => {
    return {
      key: i,
      text: `${banco.COMPE} - ${banco.LongName}`,
      value: banco.COMPE,
    };
  });

  const [types, setTypes] = useState([
    {
      id: 0,
      nome: "",
    },
  ]);

  const getTypeAccount = async () => {
    try {
      const response = await SysTypesApi.sysTypeAccount(1, 100, "");
      setTypes(response);
    } catch (error: any) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTypeAccount();
  }, []);

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function validateCNPJ(cnpj: any) {
    const temp = cnpj.match(/\d/g).join("");
    if (temp.length > 11) {
      if (!cnpjValidator.isValid(temp)) {
        setError("cnpjDestinatario", {
          type: "onBlur",
          message: "Este CNPJ não é válido!",
        });
      } else {
        setError("cnpjDestinatario", { type: "onBlur", message: "" });
      }
    } else {
      if (!cpfValidator.isValid(temp)) {
        setError("cnpjDestinatario", {
          type: "onBlur",
          message: "Este CPF não é válido!",
        });
      } else {
        setError("cnpjDestinatario", { type: "onBlur", message: "" });
      }
    }
  }
  const [openCodeModal, setOpenCodeModal] = useState(false);

  return (
    <Flex flexDir={"column"} height="fit-content" width="100%">
      <Box
        width={"100%"}
        bgColor={WHITE}
        height={"fit-content"}
        shadow={"md"}
        justifyItems={"center"}
        mt={"0.3%"}
        mx="auto"
        py={2}
        px={3}
      >
        <Flex
          justify="flex-start"
          px={5}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Text fontWeight={"bold"} fontSize={"18px"}>
            Nova Solicitação de Transferência
          </Text>
          <Button
            leftIcon={<FiArrowLeft />}
            bgColor={GRAY_NEUTRAL}
            style={{ color: "white" }}
            onClick={() => {
              goToTransferSolicitationList(navigate);
            }}
          >
            Voltar
          </Button>
        </Flex>
      </Box>
      <Flex w={"100%"} h={"84vh"} overflowY={"scroll"} flexDirection={"column"}>
        <Box
          width={"100%"}
          bgColor={WHITE}
          height={"fit-content"}
          shadow={"md"}
          justifyItems={"center"}
          mt={"0.3%"}
          mx="auto"
          py={2}
          px={3}
        >
          <Flex justify="flex-start" ml={4} flexDirection={"column"}>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={BLUEMONEDD}
              my={1}
            >
              * Solicitações de transferências bancárias só são possíveis de 00h
              até ás 16h, de segunda a sexta exceto feriados.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={BLUEMONEDD}
              my={1}
            >
              * Não é possível realizar solicitações de transferências bancárias
              após as 16:00, em finais de semana e feriados nacionais.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={BLUEMONEDD}
              my={1}
            >
              * Importante: Todas as transferências realizadas que tiverem
              registrado em suas contas, CHAVE PIX, serão processados como PIX
              no banco.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={BLUEMONEDD}
              my={1}
            >
              * A partir de 1º de Novembro de 2023, todo cliente MONEDD tem o
              benefício de 20 Transferências GRATUÍTAS dentro de cada mês e sem
              limite diário. A partir da 21ª transferência dentro do mês, custo
              unitário de R$ 4,50 por transferência sendo fechamento e
              lançamento mensal.
            </Text>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <Flex width={"100%"} height={"60%"} flexDirection="column" mb={"3%"}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <Flex my={2} flexDirection={"column"} justifyContent="center">
                <Text fontWeight={"bold"} my={1}>
                  Saldo:{" "}
                  {loading ? (
                    <Spinner size={"sm"} color={BLUEMONEDDBUTTONS}></Spinner>
                  ) : saldoCliente ? (
                    saldoCliente.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                  ) : (
                    "R$ 0,00"
                  )}
                </Text>
              </Flex>
              <FormControl my={2} w={"40%"}>
                <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                  Lista de Favorecidos
                </FormLabel>
                <SelectFavorite cliente={id} setFavorite={setFavorite} />
              </FormControl>
              <Flex flexDir={"row"}>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Nome
                  </FormLabel>
                  <Input
                    placeholder="Digite o nome"
                    value={pagamento.nomeDestinatario}
                    {...register("nomeDestinatario", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        nomeDestinatario: e.target.value,
                      });
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    CPF/CNPJ
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    format={
                      unMask(pagamento.cnpjDestinatario).length > 11
                        ? "##.###.###/####-##"
                        : "###.###.###-###"
                    }
                    type="text"
                    placeholder="Digite o CPF ou CNPJ"
                    value={pagamento.cnpjDestinatario}
                    // {...register("cnpjDestinatario", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        cnpjDestinatario: e.target.value,
                      });
                    }}
                    onBlur={(e: any) => {
                      validateCNPJ(e.target.value);
                    }}
                  />
                  <Text color={REDMONEDD}>
                    {errors.cnpjDestinatario?.message}
                  </Text>
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Valor
                  </FormLabel>
                  <NumericFormat
                    decimalScale={2}
                    prefix="R$ "
                    value={pagamento.valor}
                    decimalSeparator=","
                    customInput={Input}
                    type="text"
                    placeholder="R$ 0,00"
                    onChange={(e: any) => {
                      OnChangeValueInput(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                    Observação
                  </FormLabel>
                  <Input
                    placeholder="observações..."
                    value={pagamento.observacao}
                    {...register("observacao", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        observacao: e.target.value,
                      });
                    }}
                  />
                </FormControl>
              </Flex>
              <Flex flexDir={"row"}>
                <FormControl
                  isInvalid={errors.nroBanco ? true : false}
                  my={2}
                  mx={2}
                >
                  <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                    Número do Banco
                  </FormLabel>
                  <BankSelector banco={pagamento} setBanco={setPagamento} />
                  {/* <Select
                    {...register("nroBanco", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({ ...pagamento, nroBanco: e.target.value });
                    }}
                  >
                    {bancoOptions.map((item: any) => {
                      return (
                        <option value={item.value} key={item.key}>
                          {item.text}
                        </option>
                      );
                    })}
                  </Select> */}
                  <FormErrorMessage>
                    {errors.nroBanco?.message}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  isInvalid={errors.nroAgencia ? true : false}
                  my={2}
                  mx={2}
                >
                  <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                    <Text>
                      Digite a Agência{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        (sem Dígito)
                      </span>
                    </Text>
                  </FormLabel>
                  <PatternFormat
                    format={"####"}
                    placeholder="NNNN"
                    // mask={["N", "N", "N", "N"]}
                    w={"160px"}
                    customInput={Input}
                    value={pagamento.nroAgencia}
                    {...register("nroAgencia", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        nroAgencia: e.target.value,
                      });
                    }}
                  />
                  <FormErrorMessage>
                    {errors.nroAgencia?.message}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  isInvalid={errors.nroConta ? true : false}
                  my={2}
                  mx={2}
                >
                  <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                    <Text>
                      Digite o Número da Conta{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        (sem Dígito)
                      </span>
                    </Text>
                  </FormLabel>
                  <Flex
                    flexDirection={"row"}
                    justifyContent={"start"}
                    alignItems={"center"}
                  >
                    <Input
                      type="text"
                      maxLength={10}
                      w={"260px"}
                      mx={1}
                      placeholder="Digite o número da conta"
                      value={pagamento.nroConta}
                      {...register("nroConta", { required: true })}
                      onChange={(e: any) => {
                        setPagamento({
                          ...pagamento,
                          nroConta: e.target.value,
                        });
                      }}
                    />
                  </Flex>
                  <FormErrorMessage>
                    {errors.nroConta?.message}
                  </FormErrorMessage>
                </FormControl>
                <FormControl my={2} mx={2}>
                  <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                    <Text>
                      Digite{" "}
                      <span style={{ fontWeight: "bold", color: "red" }}>
                        somente o Dígito
                      </span>{" "}
                      da conta
                    </Text>
                  </FormLabel>
                  <Input
                    type="text"
                    maxLength={1}
                    w={"50px"}
                    placeholder="X"
                    value={pagamento.nroContaDigito}
                    {...register("nroContaDigito", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        nroContaDigito: e.target.value,
                      });
                    }}
                  />
                </FormControl>
                <FormControl
                  isInvalid={errors.idTipoConta ? true : false}
                  my={2}
                  mx={2}
                >
                  <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                    Selecione o tipo
                  </FormLabel>
                  <Select
                    value={pagamento.idTipoConta}
                    {...register("idTipoConta", { required: true })}
                    onChange={(e: any) => {
                      setPagamento({
                        ...pagamento,
                        idTipoConta: Number(e.target.value),
                      });
                    }}
                  >
                    {types &&
                      types.map((item: any) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.nome}
                          </option>
                        );
                      })}
                  </Select>
                  <FormErrorMessage>
                    {errors.idTipoConta?.message}
                  </FormErrorMessage>
                </FormControl>
              </Flex>
              <Button
                isDisabled={
                  id !== 0 &&
                    pagamento.cnpjDestinatario !== "" &&
                    pagamento.nomeDestinatario !== "" &&
                    pagamento.nroAgencia !== "" &&
                    pagamento.nroConta !== "" &&
                    pagamento.nroContaDigito !== "" &&
                    pagamento.valor > 0 &&
                    pagamento.idTipoConta > 0
                    ? false
                    : true
                }
                onClick={() => setOpenCodeModal(true)}
                mt={5}
                leftIcon={<FiPlus />}
                bgColor={BLUEMONEDDBUTTONS}
                style={{ color: "white" }}
                _hover={{ bg: "#4B4B57" }}
                isLoading={loadingCadastro}
              >
                Cadastrar
              </Button>
            </form>
          </Flex>
        </Box>
      </Flex>
      <ModalSendACodeToLogin
        isOpen={openCodeModal}
        setIsOpen={setOpenCodeModal}
        functionPai={onSubmit}
        setCode={setCode}
        type={"transferencia"}
        email={user.email}
      />
    </Flex>
  );
}
